export const DEFAULT_ICON = 'icon-location2';
